import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles/containers/Wizard.scss';
import classNames from 'classnames';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { mapStateToProps } from '../core/utils';

@mapStateToProps((state) => ({
  osd_viewer: state.canvas_editor?.viewer,
}))
class Wizard extends Component {
  wizardRef = createRef();

  toggleBlur = (add = true) => {
    const { osd_viewer } = this.props;

    if (osd_viewer?.container && osd_viewer?.isFullPage()) {
      const canvasDiv = document.querySelector('.openseadragon-canvas');
      if (canvasDiv) {
        canvasDiv.classList.toggle('blur', add);
      }
    } else {
      const root = document.getElementById('root');
      if (root) {
        root.classList.toggle('blur', add);
      }
    }
  };

  componentDidMount() {
    this.toggleBlur(true);
  }

  componentWillUnmount() {
    this.toggleBlur(false);
  }

  renderContent() {
    const { medium, small, extraSmall, children, onClose } = this.props;

    return (
      <div className={styles.wrapper} ref={this.wizardRef}>
        <div
          className={classNames(styles.box, {
            [styles.medium]: medium,
            [styles.small]: small,
            [styles.extraSmall]: extraSmall,
          })}
        >
          {React.cloneElement(children, { onClose })}
        </div>

        {onClose && (
          <KeyboardEventHandler handleKeys={['esc']} onKeyEvent={onClose} />
        )}
      </div>
    );
  }

  render() {
    const { osd_viewer } = this.props;
    const content = this.renderContent();

    return osd_viewer?.container && osd_viewer.isFullPage()
      ? ReactDOM.createPortal(content, osd_viewer.container)
      : content;
  }
}

export default Wizard;
